/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createGamma } from '../../factoriesNumber.js';
export var gammaDependencies = {
  typedDependencies,
  createGamma
};